import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./TaxiFinishTravel.module.css";
import {
  faAddressBook,
  faCoins,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { separate } from "../../Functions/NumberSeprator";
const TaxiFinishTravel = ({ finishedTraverDetailState }) => {
  return (
    <div className={Style.pageHolder}>
      <ul className={Style.ReqListHolder}>
        {finishedTraverDetailState?.map((data) => {
          return (
            <li className={Style.ComponentHolder}>
              <address className={Style.AddressHolder}>
                <FontAwesomeIcon icon={faMapPin} color="#b00064" />
                <p>مبدا:{data?.routes_description.split("**")[0]}</p>
              </address>
              <address className={Style.AddressHolder}>
                <FontAwesomeIcon icon={faMapPin} color="#b00064" />
                <p>مقصد: {data?.routes_description.split("**")[1]}</p>
              </address>
              {data?.routes_description.split("**")[2]&&<address className={Style.AddressHolder}>
                <FontAwesomeIcon icon={faMapPin} color="#b00064" />
                <p>مقصد دوم: {data?.routes_description.split("**")[2]}</p>
              </address>}
              {data?.description && (
                <address className={Style.AddressHolder}>
                  <FontAwesomeIcon icon={faAddressBook} color="#b00064" />
                  <p>توضیحات: {data?.description}</p>
                </address>
              )}
              <p className={Style.passengerHolder}>
                <FontAwesomeIcon icon={faUser} color="#15a2fa" />
                {data.name}
              </p>
              <p className={Style.PriceHolder}>
                <FontAwesomeIcon icon={faCoins} color="#00d463" />
                {`${separate(data.deliver)} تومان`}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TaxiFinishTravel;
